module.exports = __webpack_public_path__ + "media/images/bau_digital_logo_bemusterung_neg-dc4b9576.png";